import HttpFactory from '../factory'
import type { ContactPointsResult, ContactPointSystem } from '../types/patient/contactPoint'
import type { LocalPatientResult, NationalHealthIdentity } from '../types/patient/patient'
import type { PractitionerResult } from '../types/practitioner/search'

class SeachModel extends HttpFactory<any[]> {
  pathPatients = '/search/patients'
  pathSearch = '/v2/search/contact-points'
  pathPractitioners = '/search/practitioners'
  pathOrganizations = '/search/organizations'
  pathPeople = '/search/people'

  async getContactPoints(phone: number): Promise<any[]> {
    let arr = []
    try {
      const response = await this.call<any>('GET', `${this.pathSearch}?phoneNumber=${phone}`)
      arr = response
    } catch (err) {}
    return arr
  }

  async getContactPointBySystem(system: any, value: string): Promise<any[]> {
    let arr = []
    try {
      const response = await this.call<any>('GET', `${this.pathSearch}?${system}=${value}`)
      arr = response
    } catch (err) {}
    return arr
  }

  async getContactPoint(sytem: ContactPointSystem, value: any): Promise<ContactPointsResult[]> {
    let arr = []
    try {
      const response = await this.call<any>(
        'GET',
        `${this.pathPeople}?contactPointValue=${value}&contactPointSystem=${sytem}`,
      )
      arr = response
    } catch (err) {}
    return arr
  }

  // TODO: split into 2 request national and local patient search. How we handle it currently is pretty unstable.
  async getPatients(data: any, type: any): Promise<LocalPatientResult[] | NationalHealthIdentity> {
    const params = data
    let arr: any[] = []
    const maxRequest = 5
    const pageSize = 200
    const maxResult = maxRequest * pageSize
    let nextPageUrl: any = `?pageSize=${pageSize}`
    let request: any = { params }
    let searchQuery: any = ''
    let urlParams: string = ''

    try {
      do {
        if (nextPageUrl !== `?pageSize=${pageSize}`) {
          request = null
          urlParams = nextPageUrl
        }
        if (request) {
          searchQuery = new URLSearchParams(params).toString()
          urlParams = `${nextPageUrl}&${searchQuery}`
        }
        const response = await this.call<any>(
          'GET',
          `${this.pathPatients}/${type}${type === 'local' ? `${urlParams}` : `?${searchQuery}`}`,
        )
        if (type === 'national') {
          arr = [response]
          nextPageUrl = null
          // TODO: Test if with this change it's still working correctly
          break
        }
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      } while (nextPageUrl && arr.length < maxResult)
    } catch (err: any) {
      if (type === 'national') {
        return err?.response?._data
      }
    }
    return arr
  }
  async getPractitioners(data: any): Promise<PractitionerResult[]> {
    const params = data
    let arr: any[] = []
    const maxRequest = 5
    const pageSize = 200
    const maxResult = maxRequest * pageSize
    let nextPageUrl: any = `?pageSize=${pageSize}`
    let request: any = { params }
    let searchQuery: any = ''
    let urlParams: string = ''
    try {
      do {
        if (nextPageUrl !== `?pageSize=${pageSize}`) {
          request = null
          urlParams = nextPageUrl
        }
        if (request) {
          searchQuery = new URLSearchParams(params).toString()
          urlParams = `${nextPageUrl}&${searchQuery}`
        }

        const response = await this.call<any>('GET', `${this.pathPractitioners}/${urlParams}`)
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      } while (nextPageUrl && arr.length < maxResult)
    } catch (err: any) {
      throw err
    }
    return arr
  }
  async searchOrganizations(data: any, abortSignal: AbortSignal | undefined) {
    try {
      const response = await this.call<any>(
        'GET',
        `${this.pathOrganizations}/?${decodeURIComponent(new URLSearchParams(data).toString())}`,
        undefined,
        undefined,
        abortSignal,
      )
      return response
    } catch (error) {
      throw error
    }
  }
  async searchPeople(data: any, abortSignal: AbortSignal | undefined) {
    try {
      const response = await this.call<any>(
        'GET',
        `${this.pathPeople}/?${decodeURIComponent(new URLSearchParams(data).toString())}`,
        undefined,
        undefined,
        abortSignal,
      )
      return response
    } catch (error) {
      throw error
    }
  }
}

export default SeachModel
